// import * as espree from 'espree';

export default function parse(...a){
  return console.log(...a);
  // return espree.parse(...a);
}
